<template>
  <div class="full-sidebar">
    Color
    <div class="sidebar-heading">{{ schemeName }}</div>
    <div class="first-section">
      <div class="group-body">
        <div class="form-group">
          <label for="colorCode">
            <div class="label">Color Code</div>
            <ColorPicker v-model="colorCode" disabled />
          </label>
        </div>
      </div>
    </div>
    <div class="button-container">
      <div class="top-button-row">
        <button type="button" class="button-2-secondary" @click="closeSidebar">Cancel</button>
        <button type="button" class="button-2-secondary" @click="openDeleteSchemeModal(scheme)">
          <i class="material-icons-outlined align-middle">delete_outline</i>
          Delete
        </button>
      </div>

      <DeleteSchemeModal
        v-if="showDeleteSchemeModal"
        @close="showDeleteSchemeModal = false"
        :scheme="selectedScheme"
        @deleted="handleSchemeDeleted"
      />
    </div>
  </div>
</template>

<script>
  import DeleteSchemeModal from '@/components/admin/OrganisationDetails/Settings/DeleteSchemeModal.vue';
  import ColorPicker from '@/components/ColorPicker.vue';

  export default {
    name: 'ColorSidebar',

    components: {
      DeleteSchemeModal,
      ColorPicker,
    },

    props: {
      scheme: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        isSaving: false,
        schemeName: '',
        colorCode: '',
        showDeleteSchemeModal: false,
        selectedScheme: null,
      };
    },
    mounted() {
      this.selectedScheme = this.scheme;
      this.schemeName = this.scheme.name;
      this.colorCode = this.scheme.config['color'];
    },
    watch: {
      scheme() {
        this.selectedScheme = this.scheme;
        this.schemeName = this.scheme.name;
        this.colorCode = this.scheme.config['color'];
      },
    },
    methods: {
      openDeleteSchemeModal(scheme) {
        this.selectedScheme = scheme;
        this.showDeleteSchemeModal = true;
      },
      closeSidebar() {
        this.$emit('close');
      },
      handleSchemeDeleted() {
        this.$emit('update');
      },
    },
  };
</script>

<style scoped>
  .full-sidebar {
    overflow: hidden;
    position: relative;
    height: 100%;
    background-color: #fff;
    width: 20vw;
    max-width: 20vw;
    min-width: 20vw;
    font-size: 14px;
    padding: 20px;
    border-top: solid 2px #f0f0f0;
    display: flex;
    flex-direction: column;
  }

  .first-section {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
  }

  .sidebar-heading {
    font-family: Poppins;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    margin-bottom: 18px;
  }

  label {
    width: 100%;
  }

  .button-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 10px;
    background-color: #ffffff;
    position: sticky;
  }

  button {
    min-width: 40px;
  }

  .top-button-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
</style>
